
<template>

<div>
  landing..
</div>
</template>

<script>



export default {
  name: 'LandingPage',
  data(){
    return {
    }
  },
  computed:{
  },
  mounted(){
    this.$router.push({path:"/home"})
  },
  created(){
  },
  methods:{
  },
  components: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
